<template>
	<v-dialog v-model="dialog" max-width="400">
		<template v-slot:activator="{ on }">
			<v-btn tile block depressed color="white" class="log-out-btn btn-profile-management" v-on="on">
				<span class="fs12 ortho-text-gray btn-profile-management-title">Déconnexion</span></v-btn
			>
		</template>
		<v-card>
			<div class="fs15 title-container pa-4">
				<h1>À bientôt !</h1>
			</div>
			<v-card-text>Tu es sur le point de te déconnecter d'OrthographIQ.</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="black" text @click="dialog = false">Annuler</v-btn>
				<v-btn dark @click="logout()" color="#F95F62">
					<v-icon>mdi-logout</v-icon>
					<span>Déconnexion</span>
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	name: 'LogOutButton',
	data() {
		return {
			dialog: false,
		};
	},
	methods: {
		logout() {
			this.$router.push({ name: 'Logout' });
		},
	},
};
</script>

<style lang="scss" scoped>
.btn-profile-management {
	&:hover {
		.btn-profile-management-title {
			color: #686bdf !important;
		}
	}
}

.title-container {
	text-align: center;
}

.log-out-btn {
	border-bottom-left-radius: 4px !important;
	border-bottom-right-radius: 4px !important;
}
</style>
